import React from "react";

export default function Services() {
  return (
    <div className="services-page">

      {/* HEADER */}
      <div className="services-hero">
        <h1>સેવાઓ</h1>
      </div>

      {/* SERVICES */}
      <div className="container">
        <h2 className="section-title">અમારી સેવાઓ / પ્રોડક્ટ્સ</h2>

        <div className="services-grid">

          <div className="service-card">
            <div className="icon">🔗</div>
            <h3>સોશિયલ લોન</h3>
            <p>
              લગ્ન, સગાઈ અથવા સામાજિક પ્રસંગ માટે લોન સુવિધા ઉપલબ્ધ.
            </p>
            <span>(વ્યાજ દર 14%)</span>
          </div>

          <div className="service-card">
            <div className="icon">👤</div>
            <h3>પર્સનલ લોન</h3>
            <p>
              બિઝનેસ, મેડિકલ ઈમરજન્સી માટે લોન ઉપલબ્ધ.
            </p>
            <span>(વ્યાજ દર 14%)</span>
          </div>

          <div className="service-card">
            <div className="icon">📊</div>
            <h3>મોર્ટગેજ લોન</h3>
            <p>
              મિલ્કત સામે સુરક્ષિત લોન સુવિધા.
            </p>
            <span>(વ્યાજ દર 12%)</span>
          </div>

          <div className="service-card">
            <div className="icon">💰</div>
            <h3>ફ્યુચર ડિપોઝિટ યોજના</h3>
            <p>સુરક્ષિત રોકાણ માટે ખાસ યોજના</p>
          </div>

          <div className="service-card">
            <div className="icon">🌱</div>
            <h3>સેવિંગ યોજના</h3>
            <p>નાની બચત માટે ખાસ યોજના</p>
          </div>

          <div className="service-card">
            <div className="icon">🛡️</div>
            <h3>વીમા યોજના</h3>
            <p>સભ્યો માટે વીમા સુરક્ષા યોજના</p>
          </div>

        </div>
      </div>

      {/* HOLIDAY TABLE */}
      <div className="container holidays">
        <h2 className="section-title">બેંક રજાઓ 2025</h2>
        <p className="note">
          નોંધ: દર મહિને 2મો અને 4મો શનિવાર રજા રહેશે.
        </p>

        <table>
          <thead>
            <tr>
              <th>ક્રમાંક</th>
              <th>તારીખ</th>
              <th>રજાનું નામ</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>1</td><td>14 જાન્યુઆરી</td><td>મકર સંક્રાંતિ</td></tr>
            <tr><td>2</td><td>25 માર્ચ</td><td>હોળી</td></tr>
            <tr><td>3</td><td>20 જુલાઈ</td><td>ગુરુ પૂર્ણિમા</td></tr>
            <tr><td>4</td><td>19 ઓગસ્ટ</td><td>રક્ષાબંધન</td></tr>
            <tr><td>5</td><td>26 ઓગસ્ટ</td><td>જન્માષ્ટમી</td></tr>
            <tr><td>6</td><td>07 સપ્ટેમ્બર</td><td>ગણેશ વિસર્જન</td></tr>
            <tr><td>7</td><td>12 ઑક્ટોબર</td><td>દશેરા</td></tr>
            <tr><td>8</td><td>01 નવેમ્બર - 10 નવેમ્બર</td><td>દિવાળી વેકેશન</td></tr>
          </tbody>
        </table>
      </div>

    </div>
  );
}